import type { PointArray } from '../types/contour-definition-array-type';

import { EPSILON } from '@/src/constants';

/**
 * Removes duplicate points from a polyline
 * @param points Input array of points
 * @returns New array with duplicate points removed
 */
export function removeDuplicatePoints(points: PointArray): PointArray {
  if (points.length <= 1) return [...points];

  const result: PointArray = [];
  const seen = new Set<string>();

  for (let i = 0; i < points.length; i++) {
    const point = points[i];
    // Round coordinates to handle floating point precision
    const x = Math.round(point.x / EPSILON) * EPSILON;
    const y = Math.round(point.y / EPSILON) * EPSILON;

    // Create a unique key for the point
    const key = `${x},${y}`;

    if (!seen.has(key)) {
      seen.add(key);
      result.push({ x: point.x, y: point.y });
    }
  }

  return result;
}
